export enum Authority {
	SUPERADMIN = 'ROLE_SUPERADMIN',
	ADMIN = 'ROLE_ADMIN',
	ADMIN_EMPLOYEE = 'ROLE_ADMIN_EMPLOYEE',
	PZE = 'ROLE_PZE',
	USER = 'ROLE_USER',
	YOUTRACK = 'ROLE_YOUTRACK',
}
